import { classNames } from '@/utils/methods'
import { ErrorLayout, ErrorLayoutProps } from '@saasalerts/ui'
import { FC } from 'react'

export const SomethingWentWrong: FC<
  React.PropsWithChildren<ErrorLayoutProps>
> = ({ className = '' }) => {
  return (
    <ErrorLayout className={classNames('bg-white', className)}>
      <ErrorLayout.Graphic>
        <img
          className="h-24"
          src="/images/data-error.png"
          alt="Something went wrong"
        />
      </ErrorLayout.Graphic>
      <ErrorLayout.Title>Something went wrong</ErrorLayout.Title>

      <ErrorLayout.Body>
        We were unable to fetch the data. Please try again or change the
        filters. If the problem persists, please contact support.
      </ErrorLayout.Body>
    </ErrorLayout>
  )
}
